// First and last names typed on the website (sign-up and My Account).
//
// A name is shown back on many pages and in emails, so it must never carry
// markup. A name keeps letters in any script (Arabic included, with its
// vowel marks), spaces, hyphens, apostrophes and dots ("Al-Ayoub", "O'Neil",
// "Abd. Al"), and nothing else: no <, >, &, quotes, slashes, digits or
// brackets.

export const NAME_MAX_LENGTH = 50;

// Letters (\p{L}), combining marks such as Arabic harakat (\p{M}), space,
// hyphen, dot, and the straight and curly apostrophe.
const NOT_ALLOWED = /[^\p{L}\p{M} '’.-]/gu;
const ONLY_ALLOWED = /^[\p{L}\p{M} '’.-]*$/u;
// Any other space (a pasted no-break space, a tab) becomes a plain one, so
// "Faisal Alayoub" pasted from elsewhere does not turn into "FaisalAlayoub".
const OTHER_SPACE = /[^\S ]/gu;

// What the field keeps as the customer types: every other character is
// dropped, and the name is cut at NAME_MAX_LENGTH characters. Spaces are
// left alone, so a space typed between two names is not lost mid-typing.
export const cleanName = (value) => {
  if (value === null || value === undefined) return "";
  const kept = String(value).replace(OTHER_SPACE, " ").replace(NOT_ALLOWED, "");
  return Array.from(kept).slice(0, NAME_MAX_LENGTH).join("");
};

// True when the name holds only allowed characters and is not too long. An
// empty name passes here; "required" is a separate rule.
export const isValidName = (value) => {
  if (value === null || value === undefined) return true;
  const text = String(value);
  return ONLY_ALLOWED.test(text) && Array.from(text).length <= NAME_MAX_LENGTH;
};

// The rule for SimpleReactValidator, used as "required|personName".
export const nameValidators = {
  personName: {
    message:
      "The :attribute may only contain letters, spaces, hyphens, apostrophes and dots (at most " +
      NAME_MAX_LENGTH +
      " characters).",
    rule: (val) => isValidName(val),
  },
};
